
import React, { Component } from 'react';
import '../App.css';
import { connect } from 'react-redux';
import { store } from '../redux/store';
import { actions } from '../redux/action';
import { Spin } from 'antd';
import { Layout, Button } from 'antd';
import SingeChoiceQuestion from './surveyQuestions/singeChoiceQuestion';
import ShortTextQuestion from './surveyQuestions/shortTextQuestion';
import { getQueryVariable } from './helpers';
import AlreadyCompletedPage from './alreadyCompleted';
import ThankYouPage from './thankYouPage';
import API_ERRORS from '../config';
import ErrorPage from './errorPage';
import FooterComponent from './footer';
import HeaderComponent from './header';
const { Content } = Layout;

class SurveyPage extends Component {
  constructor(props) {
    super(props);
    this.canSubmit = this.canSubmit.bind(this);
    this.sendSurvey = this.sendSurvey.bind(this);
    this.hasRequired = this.hasRequired.bind(this);
  }

  canSubmit() {
    const { surveyResponse, survey } = this.props;

    if (survey.data.Questions === undefined)
      return false;

    let requiredQuestions = [];
    survey.data.Questions.map((x) => {
      if (x.Required)
        requiredQuestions.push(x.Id);
    })
    if (requiredQuestions.length === 0)
      return true;

    for (let index = 0; index < requiredQuestions.length; index++) {
      const questionId = requiredQuestions[index];
      let answer = surveyResponse.data.answers.find(x => x.questionId === questionId)
      if (answer === undefined)
        return false;
    }
    return true;
  }

  hasRequired() {
    const { survey } = this.props;

    if (survey.data.Questions === undefined)
      return false;

    let requiredQuestions = [];
    survey.data.Questions.map((x) => {
      if (x.Required)
        requiredQuestions.push(x.Id);
    })
    if (requiredQuestions.length === 0) {
      return false;
    }
    return true;
  }

  sendSurvey() {
    const { surveyResponse, surveyResponseLoading } = this.props;
    if (surveyResponseLoading === false)
      store.dispatch(actions.sendSurveyResponse(surveyResponse))
  }

  componentDidMount() {
    const surveyKey = getQueryVariable("key"),
      stayGuid = getQueryVariable("guid"),
      status = getQueryVariable("status");

    // If status=done is present skip API calls
    // We set the status on success response from survey in saga
    if (status === 'done') {
      return;
    }

    if (surveyKey && stayGuid) {
      store.dispatch(actions.getSurvey(surveyKey, stayGuid));
      store.dispatch(actions.setUrlData(surveyKey, stayGuid));
    }
  }

  render() {
    const { survey, surveyResponseLoading, apiResponseSuccess } = this.props,
      CanSubmit = this.canSubmit(),
      showRequired = this.hasRequired(),
      surveyTitle = survey.data.LocationName !== undefined ? survey.data.LocationName : "";
      const surveyKey = getQueryVariable("key"),
      stayGuid = getQueryVariable("guid"),
      status = getQueryVariable("status");

    if (status === 'done') {
      return <ThankYouPage title={surveyTitle} />;
    }

    if (survey.error.errorCode !== undefined || survey.data.length === 0) {
      if (survey.error.errorCode === API_ERRORS.SURVEY_ALREADY_COMPLETED.code) {
        return (<AlreadyCompletedPage title={survey.error.paramsAsStrings[0]} />);
      }
      if (survey.error.errorCode === API_ERRORS.SURVEY_STAY_NOT_FOUND.code || survey.error.errorCode === API_ERRORS.SURVEY_NOT_FOUND.code) {
        return (<ErrorPage title={surveyTitle} />);
      }
      if (survey.error.errorCode === API_ERRORS.INVALID_SURVEY_REQUEST.code || survey.error.errorCode === API_ERRORS.UNKNOW_ERROR.code || !surveyKey || !stayGuid) {
        return (<ErrorPage title={surveyTitle} errorMessage={API_ERRORS.UNKNOW_ERROR.message} />);
      }
    }
    if (apiResponseSuccess && apiResponseSuccess === true) {
      return (<ThankYouPage title={surveyTitle} />);
    }

    return (
      <Layout style={{ height: "100%" }}>
        <HeaderComponent />
        <Content>
          <div className='ticketRow'>
            <div className='label'>Location:</div>
            <div className='value'>{surveyTitle}</div>
          </div>
          <div className="Survey-Holder">
            {survey.loading ?
              <div className="Spinner">
                <Spin />
              </div>
              :
              <div style={{ padding: '20px' }}>
                {showRequired === true ?
                  <div>
                    <p style={{ color: 'red' }}><i>* indicates that the question is required</i></p>
                  </div>
                  : null}
                {survey.data.Questions !== undefined && survey.loading === false ?
                  survey.data.Questions.map((x, i) => {
                    const QuestionCount = i + 1;
                    if (x.QuestionType.Name === "SingleChoice")
                      return (
                        <SingeChoiceQuestion
                          key={`question-${QuestionCount}`}
                          questionId={x.Id}
                          questionText={x.Text}
                          required={x.Required}
                          answers={x.Answers}
                          questionNumber={QuestionCount}
                        />)
                    if (x.QuestionType.Name === "ShortText")
                      return (<ShortTextQuestion
                        key={`question-${QuestionCount}`}
                        questionText={x.Text}
                        required={x.Required}
                        questionId={x.Id}
                        questionNumber={QuestionCount}
                      />)
                  }
                  )
                  : null
                }
                <Button type="primary" onClick={this.sendSurvey} disabled={!CanSubmit} loading={surveyResponseLoading}>
                  {surveyResponseLoading ?
                    <span>Sending...</span> :
                    <span>Send</span>
                  }
                </Button>
              </div>
            }
          </div></Content>
        <FooterComponent />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return {
    survey: state.survey,
    surveyResponse: state.surveyResponse,
    surveyResponseLoading: state.surveyResponse.loading,
    apiResponseSuccess: state.surveyResponse.apiResponseSuccess,
  };
};
export default connect(mapStateToProps)(SurveyPage);